module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "units-by-college"
  }, [(_vm.currentView !== "collegeView" && _vm.showCollege) ? _c('div', {
    staticClass: "unit-college"
  }, [_vm._v(_vm._s((_vm.college.values[0].values[0].college || {}).name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-items"
  }, _vm._l((_vm.college.values), function(program) {
    return _c('program', {
      key: program.key,
      attrs: {
        "program": program
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6037c003","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/college.vue
// module id = 998
// module chunks = 1